import { render, staticRenderFns } from "./search-result.vue?vue&type=template&id=0f4b63f2&scoped=true"
import script from "./search-result.vue?vue&type=script&lang=js"
export * from "./search-result.vue?vue&type=script&lang=js"
import style0 from "./search-result.vue?vue&type=style&index=0&id=0f4b63f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b63f2",
  null
  
)

export default component.exports